var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2833_2385",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2833_2385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "image_2",
    d: "M4.66675 21C4.21675 21 3.82642 20.8348 3.49575 20.5043C3.16525 20.1736 3 19.7833 3 19.3333V4.66675C3 4.21675 3.16525 3.82642 3.49575 3.49575C3.82642 3.16525 4.21675 3 4.66675 3H19.3333C19.7833 3 20.1736 3.16525 20.5043 3.49575C20.8348 3.82642 21 4.21675 21 4.66675V19.3333C21 19.7833 20.8348 20.1736 20.5043 20.5043C20.1736 20.8348 19.7833 21 19.3333 21H4.66675ZM4.66675 19.3333H19.3333V4.66675H4.66675V19.3333ZM5.93325 17.05H18.0833L14.3833 12.1168L11.1833 16.3L8.88325 13.1833L5.93325 17.05Z",
    fill: "#1C1B1F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.dc89c3adab1054ac270d4ed83abfc18d.svg";
export { ForwardRef as ReactComponent };